import { render, staticRenderFns } from "./st-page-header.vue?vue&type=template&id=a9e8064c&scoped=true"
import script from "./st-page-header.vue?vue&type=script&lang=js"
export * from "./st-page-header.vue?vue&type=script&lang=js"
import style0 from "./st-page-header.vue?vue&type=style&index=0&id=a9e8064c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e8064c",
  null
  
)

export default component.exports